module.exports = __webpack_public_path__ + "static/img/app-1.f4b1519c.jpg";